import React from 'react';
import { Table, Button } from 'antd';
import type { SupportTicket } from '../../../api/support';

interface SupportTicketsTableProps {
  tickets: SupportTicket[];
  loading: boolean;
  pagination: any;
  onEdit: (ticket: SupportTicket) => void;
  onView: (ticket: SupportTicket) => void;
  onTableChange: (pagination: any) => void;
}

const SupportTicketsTable: React.FC<SupportTicketsTableProps> = ({ tickets, loading, pagination, onEdit, onView, onTableChange }) => {
  const columns = [
    { title: 'Subject', dataIndex: 'subject', key: 'subject' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    { title: 'Priority', dataIndex: 'priority', key: 'priority' },
    { title: 'Assigned To', dataIndex: 'assigned_to', key: 'assigned_to' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: SupportTicket) => (
        <>
          <Button type="link" onClick={() => onView(record)}>View</Button>
          <Button type="link" onClick={() => onEdit(record)}>Edit</Button>
        </>
      ),
    },
  ];
  return (
    <Table
      columns={columns}
      dataSource={tickets}
      loading={loading}
      pagination={pagination}
      rowKey="id"
      onChange={onTableChange}
    />
  );
};

export default SupportTicketsTable; 